import React, { useRef, useState } from "react";
import {
  FileUploadContainer,
  FormField,
  DragDropText,
  UploadFileBtn,
  FilePreviewContainer,
  ImagePreview,
  PreviewContainer,
  PreviewList,
  FileMetaData,
  RemoveFileIcon,
  InputLabel
} from "./file-upload.styles";

import delete_icon from '../../assets/images/delete-icon.jpeg'
import { propTypes } from "react-bootstrap/esm/Image";

const KILO_BYTES_PER_BYTE = 50000;
const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 500000000;

const convertNestedObjectToArray = (nestedObj) =>
  Object.keys(nestedObj).map((key) => nestedObj[key]);

const convertBytesToKB = (bytes) => Math.round(bytes / KILO_BYTES_PER_BYTE);

const FileUpload = ({
  label,
  updateFilesCb,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  previewSize,
  isEducation,
  fileName,
  setApplicationDetails,
  applicationDetails,
  savedFile,
  handleRemoveItem,
  downloadFile,
  loaderFile,
  marginLeft,
  dragText,
  showFileModel,
  hide,
  ...otherProps
}) => {
  const fileInputField = useRef(null);
  const [files, setFiles] = useState({});

  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };

  const [hasUploaded, setHasUploaded] = useState(true)


  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        setHasUploaded(false)
        if (!otherProps.multiple) {
          return { file };
        }
        files[file.name] = file;
      }else{
        setHasUploaded(true)
        showFileModel(true)
      }
    }
    return { ...files };
  };

  const callUpdateFilesCb = (files) => {
    const filesAsArray = convertNestedObjectToArray(files);
    updateFilesCb(filesAsArray);
  };

  const handleNewFileUpload = (e) => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      setFiles(updatedFiles);
      callUpdateFilesCb(updatedFiles);
    }
  };

  const removeFile = (fileName) => {
    delete files[fileName];
    setFiles({ ...files });
    callUpdateFilesCb({ ...files });
  };


  return (
    <>
   {  savedFile?.fileText === undefined  && hasUploaded || savedFile?.fileText === '' ?   <FileUploadContainer isEducation={isEducation}>
        <InputLabel className="general-span-text-none-auto">{label}</InputLabel>
        {!isEducation && <DragDropText hide={hide}>Drag and drop your files here or</DragDropText>}
        <UploadFileBtn type="button" onClick={handleUploadBtnClick}>
          <i className="fas fa-file-upload" />
          <span> Upload {otherProps.multiple ? "file" : "a file"}</span>
        </UploadFileBtn>
        <FormField
          type="file"
          ref={fileInputField}
          onChange={handleNewFileUpload}
          title=""
          value=""
          {...otherProps}
        />
      </FileUploadContainer> : null }
  { savedFile?.fileText !== '' && savedFile?.fileText !== undefined  && hasUploaded ?  
  <div style={{
            width: '100%',
            backgroundColor: '#ccc',
            display: 'flex',
            justifyContent: 'space-between',
            margin: '5px 0px 5px 0px',
            marginLeft: marginLeft ? marginLeft : '',
            padding: 5}}>
            <span>
              {savedFile?.name}
            </span>
            <a 
              onClick={downloadFile} 
              style={{
                cursor: 'pointer',
                // fontWeight: loaderFile ? '' : 'bold',
                color: loaderFile ? '' : 'black'
            }}
              >{loaderFile? 'downloading...' : 'download'}</a>
            <img 
              onClick={handleRemoveItem}
              src={delete_icon} 
              style={{width: 30, height: 30, cursor: 'pointer'}}
              />
          </div> : null
    }
      {Object.keys(files).map((fileName, index) => {
        return(
          <div style={{
            width: '100%',
            backgroundColor: '#ccc',
            display: 'flex',
            justifyContent: 'space-between',
            margin: '5px 0px',
            padding: 5}}>
            <span>
              {fileName}
            </span>
            <img 
              onClick={()=>{
                removeFile(fileName) 
                handleRemoveItem()
              }}
              src={delete_icon} 
              style={{width: 30, height: 30, cursor: 'pointer'}}
              />
          </div>
        )})}
    </>
  );
};

export default FileUpload;
